<!-- 评级报告 -->
<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="title">
      <p>评级报告</p>
      <button :class="'tg' + typeInfo">
        {{
          typeInfo == 1
            ? '历史表现优秀'
            : typeInfo == 2
            ? '历史表现欠佳'
            : typeInfo == 3
            ? '历史表现一般'
            : '--'
        }}
      </button>
    </div>

    <div class="list">
      <van-row>
        <van-col span="8" class="left">1年内信号数量：</van-col>
        <van-col span="16" class="right">{{ ReportGradeResult.HistoryCount || '--' }}次</van-col>
        <van-col span="8" class="left">最优平均涨跌幅：</van-col>
        <van-col span="16" class="right"
          >持股<span>{{ ReportGradeResult.BestAvgCycle }}</span
          >天，涨幅
          <span :class="[judgeColor(ReportGradeResult.BestAvgRate)]">
            {{ toFixedNum(ReportGradeResult.BestAvgRate * 100, 2, '%') }}
          </span>
        </van-col>
        <van-col span="8" class="left">最大上涨概率：</van-col>
        <van-col span="16" class="right"
          >持股<span>{{ ReportGradeResult.MaxRiseCycle }}</span
          >天，上涨概率
          <span :class="[judgeColor(ReportGradeResult.MaxRiseRate)]">
            {{ toFixedNum(ReportGradeResult.MaxRiseRate * 100, 2, '%') }}
          </span>
        </van-col>
        <van-col span="8" class="left">回测周期：</van-col>
        <van-col span="16" class="right">
          {{ formatStrTime(startDate) }}
          <span class="ds-box">至</span>
          {{ formatStrTime(endDate) }}
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { judgeColor, toFixedNum, formatStrTime } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Home',
  mixins: [mixin],
  props: ['ReportGradeResult', 'startDate', 'endDate'],
  data() {
    return {
      typeInfo: 0 //评级报告信号类型
    };
  },
  filters: {},
  created() {},
  watch: {},
  mounted() {
    /**
     * 计算信号值
     * 历史表现优秀(1): 年化收益率>15% and 最大回撤<年化收益率
     * 历史表现欠佳(2): 年化收益率<0
     * 历史表现一般(3): 除了上面两种情况，为历史表现一般
     */
    if (
      this.ReportGradeResult.MaxRiseRate * 100 > 55 &&
      this.ReportGradeResult.BestAvgRate * 100 > 1
    ) {
      this.typeInfo = 1;
    } else if (
      this.ReportGradeResult.MaxRiseRate * 100 < 45 &&
      this.ReportGradeResult.BestAvgRate * 100 < 1
    ) {
      this.typeInfo = 2;
    } else {
      this.typeInfo = 3;
    }
  },
  methods: {
    judgeColor,
    toFixedNum,
    formatStrTime
  }
};
</script>
<style lang="less" scoped>
.tg2 {
  background: linear-gradient(270deg, #00701e 0%, #5db688 100%);
}
.tg1 {
  background: linear-gradient(270deg, #cd0000 0%, #f76825 100%);
}
.tg3 {
  background: linear-gradient(270deg, #3a497f 0%, #99a4ce 100%);
}
.index-info {
  padding: 15px;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      font-weight: 600;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
    }
    button {
      border-radius: 2px;
      font-weight: 400;
      font-size: 12px;
      color: #fff;
      padding: 2px 4px;
    }
  }
  .list {
    line-height: 25px;
    margin-top: 10px;
    font-size: 12px;
    .left {
      font-weight: 400;
      color: #999;
    }
    .right {
      text-align: right;
      color: #555;
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title {
    p {
      color: #e4e9fe;
    }
  }
  .list {
    .left {
      color: #6b7687;
    }
    .right {
      color: #e4e9fe;
    }
  }
}
</style>
